
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './BlogSection.css';
import API_BASE_URL from '../../config'; 
const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false); //changed by Yash for display comming soon....
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/blogs`) // Change to your backend API URL
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch blogs');
        return res.json();
      })
      .then((data) => {
        console.log(data)
        setBlogs(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading blogs...</p>;
  if (error) return <div className='error-section'>Error loading blogs: {error}</div>;

  const mainBlog = blogs[0];
  const sideBlogs = blogs.slice(1, 4);

  return (
    <section className="blog-section-light">
      <div className="blog-container">
        <h2 className="section-heading">Read our Articles & Publications</h2>
        {/* <h4 className="section-heading" style={{fontSize:'1.5rem'}}>Comming Soon...</h4> */}
        <div className="blog-columns">
          {/* Main blog */}
          {mainBlog && (
            <div className="main-blog">
              <Link to={`/blog/${mainBlog.slug}`}>
                <img src={mainBlog.image_url} alt={mainBlog.title} className="main-image" />
              </Link>
              <div className="main-content">
                <Link to={`/blog/${mainBlog.slug}`} className="main-title-link">
                  <h3 className="main-title">{mainBlog.title}</h3>
                </Link>
                <p className="main-desc">{mainBlog.description}</p>
              </div>
            </div>
          )}

          {/* Side blogs */}
          <div className="side-blogs">
            {sideBlogs.map((blog) => (
              <div key={blog.slug} className="side-blog">
                <Link to={`/blog/${blog.slug}`}>
                  <img src={blog.image_url} alt={blog.title} />
                </Link>
                <div className="side-blog-content">
                  <Link to={`/blog/${blog.slug}`} className="side-title-link">
                    <div className="side-blog-title">{blog.title}</div>
                  </Link>
                  {/* <div className="side-blog-desc">{blog.description}</div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
